import { render, staticRenderFns } from "./sendTestEmail.vue?vue&type=template&id=0756f973&"
import script from "./sendTestEmail.vue?vue&type=script&lang=js&"
export * from "./sendTestEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports